import React from 'react';
import { Alert, Button, Col, Form, Modal } from 'react-bootstrap';
import WorkflowSequence from './WorkflowSequence';
import './WorkflowChange.css';

export default function WorkflowChange(props) {
    return <Modal show={props.showUpdateWorkflow} onHide={props.saving ? () => {} : props.hideUpdateWorkflow}
        backdrop="static" centered size="lg" dialogClassName="workflow-dialog" aria-labelledby="update-workflow-title">
        <Modal.Header closeButton={!props.saving}><Modal.Title id="update-workflow-title">Update Workflow</Modal.Title></Modal.Header>
        <Modal.Body>
            <Form id="workflow-update-form" onSubmit={event => { event.preventDefault(); props.handleUpdateWorkflow(); }}>
                <fieldset disabled={props.saving}>
                    <Form.Row>
                        <Form.Group as={Col} controlId="workflow-update-name">
                            <Form.Label>Name</Form.Label>
                            <Form.Control value={props.workflow.Name} onChange={props.handleUpdateName} />
                        </Form.Group>
                        <Form.Group as={Col} controlId="workflow-update-description">
                            <Form.Label>Description</Form.Label>
                            <Form.Control value={props.workflow.Description} onChange={props.handleUpdateDescription} />
                        </Form.Group>
                    </Form.Row>
                    <WorkflowSequence inputId="workflow-update-process" value={props.workflow.Sequence}
                        onChange={props.handleUpdateSequence} {...props.sequenceProps} />
                </fieldset>
            </Form>
            {props.error && <Alert variant="danger" role="alert">{props.error}</Alert>}
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" disabled={props.saving} onClick={props.hideUpdateWorkflow}>Cancel</Button>
            <Button type="submit" form="workflow-update-form" disabled={props.saving}>{props.saving ? 'Saving…' : 'Update'}</Button>
        </Modal.Footer>
    </Modal>;
}
